import { create } from 'zustand'

// Zustandのストア作成
const useStore = create((set) => ({
  // ユーザー認証状態
  isAuthenticated: false,
  // ユーザー認証状態を更新する関数
  setIsAuthenticated: (isAuthenticated) => set({ isAuthenticated }),

  // 登録・更新成功メッセージ
  successMessage: '',
  // 登録・更新成功メッセージを更新する関数
  setSuccessMessage: (successMessage) => set({ successMessage }),
}))

export default useStore
